/* eslint-disable no-unused-vars */
/*
 * @title App
 * @description Application entry point
 */

import 'regenerator-runtime/runtime';
import Focus  from './components/focus';
import Menu  from './components/menu';
import Slider  from './components/slider.js';
// import Tabs  from './components/tabs';
import Select  from './components/select';
import Accordions  from './components/accordions';
import Toggle  from './components/toggle';
import DatePicker  from './components/datepicker';
import PlayVideo  from './components/video';
import Tracking  from './components/contact_tracking';
import Links  from './components/links';

import Collapse from 'bootstrap/js/dist/collapse';

import './components/sliders.js';
import './components/utils.js';
import './components/readmore.js';
import './components/form.js';
import './components/poi-map.js';
import './components/pagination.js';
import './components/maquette3d.js';

document.addEventListener('DOMContentLoaded', function() {
    Focus();
    Menu();
    Slider();
    // Tabs();
    Select();
    Accordions();
    Toggle();
    DatePicker();
    PlayVideo();
    Tracking();
    Links();
}, );
